module.exports = __webpack_public_path__ + "static/img/logo_footer.15919b08.png";